var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon success-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 49.993 50"}},[_c('path',{attrs:{"d":"M25 0a25 25 0 1025 25A25 25 0 0025 0zm-4.062 33.525l-7.1-6.672 2.839-2.667 4.255 4L33.31 16.553l2.847 2.675z","fill":"#345995","fill-rule":"evenodd"}})])};var toString = function () {return "/Users/Admin/Code/boxes/commerceco/static/assets/icons/SuccessIcon.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./static/assets/icons/SuccessIcon.svg
// module id = ikT0
// module chunks = 0